import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

import * as Highcharts from 'highcharts';

import { LicencaService } from 'src/app/licenca/licenca.service';
import { EmpresaService } from 'src/app/empresa/empresa.service';
import { AuthService } from 'src/app/seguranca/auth.service';
import { EstatisticaService } from 'src/app/estatistica/estatistica.service';
import { Licenca } from 'src/app/licenca/licenca.model';
import { PedidoFilter } from 'src/app/pedido/pedido-filter';

declare var require: any;
const Boost = require('highcharts/modules/boost');
const noData = require('highcharts/modules/no-data-to-display');
const More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-estatistica-clientes',
  templateUrl: './estatistica-clientes.component.html',
  styleUrls: ['./estatistica-clientes.component.css']
})
export class EstatisticaClientesComponent implements OnInit {
  jwtPayload: any;
  empresasOptions: any[];
  licencasOptions: any[];
  licencas: Licenca[];
  pedidoFilter: PedidoFilter;
  altura = 250;

  public barClientesMonetarioOptions: any = {
    chart: {
      type: 'bar',
      height: 250
    },
    title: {
      text: 'Vendas por cliente',
      x: 0
    },
    subtitle: {
      text: 'Monetário',
      x: 0
    },
    xAxis: {
      categories: [],
      title: {
        text: null
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
      labels: {
        overflow: 'justify'
      }
    },
    tooltip: {
      valuePrefix: '$'
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: false
        }
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top', x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      shadow: true,
      enabled: false
    },
    credits: {
      enabled: false
    },
    series: [{
      name: 'Total',
      data: []
    }]
  };

  public barClientesQuantitativoOptions: any = {
    chart: {
      type: 'bar',
      height: 250
    },
    title: {
      text: 'Vendas por cliente',
      x: 0
    },
    subtitle: {
      text: 'Quantitativo',
      x: 0
    },
    xAxis: {
      categories: [],
      title: {
        text: null
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
      labels: {
        overflow: 'justify'
      }
    },
    tooltip: {
      valuePrefix: ''
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: false
        }
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top', x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      shadow: true,
      enabled: false
    },
    credits: {
      enabled: false
    },
    series: [{
      name: 'Quantidade',
      data: []
    }]
  };

  constructor(
    private authService: AuthService,
    private empresaService: EmpresaService,
    private licencaService: LicencaService,
    private estatisticaService: EstatisticaService
  ) { }

  ngOnInit() {
    this.jwtPayload = this.authService.getJwtPayload();

    this.pedidoFilter = new PedidoFilter(this.jwtPayload.usuarioEmpresaId);
    this.pedidoFilter.environment = 'production';
    this.pedidoFilter.selectedSituacoes = [0, 1, 2, 3, 4, 5, 8, 9, 10, 11, 13];
    this.pedidoFilter.moeda = undefined;
    this.pedidoFilter.limit = 5;


    this.empresaService.getEmpresas().subscribe(
      empresas => {
        this.empresasOptions = [];
        empresas.forEach(empresa => {
          let name = empresa.nomeFantasia;
          if (empresa.type === 'PF') {
            name = empresa.razaoSocial + ' ' + name;
          } else {
            name = empresa.razaoSocial + ' | ' + name;
          }
          this.empresasOptions.push(
            { label: name.toUpperCase(), value: empresa.id, ativa: empresa.ativa }
          );
        });
      },
      err => {
        console.log('Error:', err);
      },
      () => {
        this.empresasOptions.sort(function (a, b) {
          if (a.label > b.label) {
            return 1;
          }
          if (a.label < b.label) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        this.buscarLicencas();
      }
    );

  }

  buscarLicencas() {
    this.pedidoFilter.licencaId = undefined;
    this.licencaService.buscarPorEmpresa(this.pedidoFilter.empresaId).subscribe(
      licencas => {
        this.licencas = licencas;
        this.licencasOptions = [];
        for (let licenca of licencas) {
          if (this.pedidoFilter.empresaId === this.jwtPayload.usuarioEmpresaId && this.jwtPayload.licencasPermitidas.length > 0 && !this.jwtPayload.licencasPermitidas.includes(licenca.id)) {
            continue;
          }
          this.licencasOptions.push(
            { label: `${licenca.contrato} [${licenca.moeda}]`, value: licenca.id, moeda: licenca.moeda }
          );
          if (this.pedidoFilter.licencaId === undefined) {
            this.pedidoFilter.licencaId = licenca.id;
          }
        }
      },
      err => console.log('Error:', err)
    );
  }

  buscar() {
    this.licencas.forEach(
      licenca => {
        if (licenca.id === this.pedidoFilter.licencaId) {
          this.pedidoFilter.moeda = licenca.moeda;
        }
      }
    );

    this.estatisticaService.getEstatisticaClientesMonetario(this.pedidoFilter).subscribe(
      result => {
        let h = 90;
        this.barClientesMonetarioOptions.xAxis.categories = [];
        this.barClientesMonetarioOptions.series[0].data = [];
        this.barClientesMonetarioOptions.tooltip.valuePrefix = this.pedidoFilter.moeda === 'BRL' ? 'R$ ' : '$';
        for (const value of result) {
          this.barClientesMonetarioOptions.xAxis.categories.push(value.forma);
          this.barClientesMonetarioOptions.series[0].data.push(value.total);
          h += 30;
        }
        if (h > 250) {
          this.barClientesMonetarioOptions.chart.height = h;
        } else {
          this.barClientesMonetarioOptions.chart.height = 250;
        }
        Highcharts.chart('chart-clientes-monetario', this.barClientesMonetarioOptions);
      },
      err => {
        console.log('Error:', err);
      }
    );

    this.estatisticaService.getEstatisticaClientesQuantitativo(this.pedidoFilter).subscribe(
      result => {
        let h = 90;
        this.barClientesQuantitativoOptions.xAxis.categories = [];
        this.barClientesQuantitativoOptions.series[0].data = [];
        for (const value of result) {
          this.barClientesQuantitativoOptions.xAxis.categories.push(value.forma);
          this.barClientesQuantitativoOptions.series[0].data.push(value.qtd);
          h += 30;
        }
        if (h > 250) {
          this.barClientesQuantitativoOptions.chart.height = h;
        } else {
          this.barClientesQuantitativoOptions.chart.height = 250;
        }
        Highcharts.chart('chart-clientes-quantitativo', this.barClientesQuantitativoOptions);
      },
      err => {
        console.log('Error:', err);
      }
    );
  }

  hasPermission(permission: string) {
    return this.jwtPayload.authorities.includes(permission);
  }

}
